import {
    EDIT_AWARD_REQUEST,
    EDIT_AWARD_SUCCESS,
    EDIT_AWARD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editAwardReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_AWARD_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_AWARD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_AWARD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editAwardReducer;
